import { render, staticRenderFns } from "./ProductsWidget.vue?vue&type=template&id=7d5b38d1&"
import script from "./ProductsWidget.vue?vue&type=script&lang=js&"
export * from "./ProductsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports